import React, {createContext, ReactNode, useContext, useEffect, useState} from 'react';
import {exitSubordinateView, isViewingAsSubordinate} from "../utils/OrgManagement.ts";

interface BannerContextType {
    showBanner: (message: string, color?: string) => void;
    hideBanner: () => void;
}

const BannerContext = createContext<BannerContextType | undefined>(undefined);

interface BannerProviderProps {
    children: ReactNode;
}

const DEFAULT_BANNER_COLOR = '#87ceff';

export const BannerProvider: React.FC<BannerProviderProps> = ({children}) => {
    const [banner, setBanner] = useState<{ message: string; color: string } | null>(null);

    const showBanner = (message: string, color: string = DEFAULT_BANNER_COLOR) => {
        setBanner({message, color});
    };

    useEffect(() => {
        if (isViewingAsSubordinate()) {
            showBanner('Je bent momenteel ingelogd als je klant');
        }
    }, []);

    const hideBanner = () => {
        setBanner(null);
        exitSubordinateView();
    };

    return (
        <BannerContext.Provider value={{showBanner, hideBanner}}>
            <div className={`flex flex-col h-screen w-screen overflow-hidden ${banner ? 'bg-primary' : 'bg-white'}`}>
                {banner && (
                    <div
                        className="bg-primary text-white py-3 px-6 z-[9999] text-center font-bold flex justify-center items-center gap-4 shrink-0">
            <span className="flex-1">
              {banner.message}
                <button
                    onClick={hideBanner}
                    className="bg-white/20 border-none text-white py-1 px-3 rounded cursor-pointer text-xs transition-colors duration-200 ml-4 hover:bg-white/30"
                >
                Ga terug
              </button>
            </span>
                    </div>
                )}
                <div
                    className={`flex-1 min-h-0 relative bg-white overflow-y-auto ${banner ? 'rounded-t-[24px]' : 'rounded-t-none'}`}>
                    {children}
                </div>
            </div>
        </BannerContext.Provider>
    );
};
